import { LineChart } from "@mui/x-charts/LineChart";
import { BarChart } from "@mui/x-charts/BarChart";
import { OvalLoader } from "../../../components/common/Loader";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { BRAND, CHART } from "../../../constant/theme";

const ChartSwiper = ({ data, ovalLoading, hasPermission, dateRangeText, side }) => {
  const chartDataSet = data.monthWiseBusinessList || [];
  const chartDataSet1 = data.monthWise121RFlVisitorList || [];
  const chartDataSet2 = data.monthWiseIncomesExpensesList || [];

  const chartHeight = 250;

  const lakhFormatter = (val) => {
    const value = val?.value !== undefined ? val.value : val;
    if (value == null || value === "") return "";
    const amount = Number(value);
    if (Math.abs(amount) >= 100000) {
      const lakhs = amount / 100000;
      const text = Number.isInteger(lakhs)
        ? String(lakhs)
        : lakhs.toFixed(1).replace(/\.0$/, "");
      return `₹${text}L`;
    }
    return `₹${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(amount)}`;
  };

  const currencyFormatter = (val) => {
    const value = val?.value !== undefined ? val.value : val;
    if (value == null) return "";
    return `₹${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(value)}`;
  };

  const yAxisFormatter = (val) => {
    const value = val?.value !== undefined ? val.value : val;
    if (value == null) return "";
    return new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(
      value,
    );
  };

  const canViewActivityCharts = hasPermission("dashboard-tyns-data-view");

  if (!canViewActivityCharts && !side && !hasPermission("dashboard-income-expense-data-view")) {
    return null;
  }

  return (
    <div className="dash-six-grid">
      {canViewActivityCharts && (
      <div className="dash-six-row">
      <div className="chart-card">
        <div className="chart-card-header">
          <div className="chart-card-title-group">
            <div className="chart-card-icon is-tile is-navy">
              <i className="bx bx-line-chart" aria-hidden="true"></i>
            </div>
            <div>
              <h3 className="chart-card-title">Overall Business Achieved</h3>
              <p className="chart-card-subtitle-text">
                {dateRangeText || "Month-wise"}
              </p>
            </div>
          </div>
        </div>
        <div className="chart-card-figure">
          {ovalLoading ? (
            <OvalLoader color="#1E3A93" />
          ) : (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className="tyntooltip">
                  {data.overallTynsAmountText || ""}
                </Tooltip>
              }
            >
              <span className="chart-card-amount">{data.overallTynsAmount}</span>
            </OverlayTrigger>
          )}
        </div>
        <div className="chart-card-body">
          {ovalLoading ? (
            <div className="chart-loader">
              <OvalLoader color={BRAND.primary} />
            </div>
          ) : chartDataSet.length > 0 ? (
            <LineChart
              dataset={chartDataSet}
              xAxis={[
                {
                  scaleType: "band",
                  dataKey: "month",
                  tickPlacement: "middle",
                  tickLabelPlacement: "middle",
                },
              ]}
              yAxis={[
                {
                  valueFormatter: lakhFormatter,
                },
              ]}
              series={[
                {
                  dataKey: "amount",
                  valueFormatter: currencyFormatter,
                  color: "#1E3A93",
                  area: true,
                  showMark: true,
                  curve: "monotoneX",
                },
              ]}
              height={chartHeight}
              margin={{ top: 20, right: 20, bottom: 30, left: 70 }}
              grid={{ vertical: true, horizontal: true }}
              sx={{
                "& .MuiAreaElement-root": {
                  fill: CHART.areaFill,
                },
                "& .MuiLineElement-root": {
                  strokeWidth: 2.5,
                },
                "& .MuiMarkElement-root": {
                  strokeWidth: 2,
                  scale: "0.8",
                  fill: "#fff",
                },
              }}
            />
          ) : (
            <div className="chart-empty">No data available</div>
          )}
        </div>
      </div>

      <div className="chart-card">
        <div className="chart-card-header">
          <div className="chart-card-title-group">
            <div className="chart-card-icon is-tile is-violet">
              <i className="bx bx-bar-chart-alt-2" aria-hidden="true"></i>
            </div>
            <div>
              <h3 className="chart-card-title">Activities Overview</h3>
              <p className="chart-card-subtitle-text">
                Visitors, 121s, RFLs and TYNs by month
              </p>
            </div>
          </div>
          <div className="chart-legend-indicators">
            <span className="chart-legend-item">
              <span className="chart-legend-dot" style={{ background: "#7C6BF2" }}></span>
              Visitors
            </span>
            <span className="chart-legend-item">
              <span className="chart-legend-dot" style={{ background: "#1ABC9C" }}></span>
              121s
            </span>
            <span className="chart-legend-item">
              <span className="chart-legend-dot" style={{ background: "#F5A623" }}></span>
              RFLs
            </span>
            <span className="chart-legend-item">
              <span className="chart-legend-dot" style={{ background: "#E74C3C" }}></span>
              TYNs
            </span>
          </div>
        </div>
        <div className="chart-card-body">
          {ovalLoading ? (
            <div className="chart-loader">
              <OvalLoader color="#1976d2" />
            </div>
          ) : chartDataSet1.length > 0 ? (
            <BarChart
              dataset={chartDataSet1}
              xAxis={[
                {
                  dataKey: "month",
                  scaleType: "band",
                  categoryGapRatio: 0.2,
                  barGapRatio: 0.05,
                },
              ]}
              yAxis={[
                {
                  valueFormatter: yAxisFormatter,
                },
              ]}
              slotProps={{ legend: { hidden: true } }}
              series={[
                {
                  dataKey: "visitor",
                  label: "Visitors",
                  color: "#7C6BF2",
                },
                {
                  dataKey: "one_to_one",
                  label: "121s",
                  color: "#1ABC9C",
                },
                {
                  dataKey: "referral",
                  label: "RFLs",
                  color: "#F5A623",
                },
                {
                  dataKey: "tyfcb",
                  label: "TYNs",
                  color: "#E74C3C",
                }
              ]}
              height={chartHeight}
              margin={{ top: 20, right: 20, bottom: 30, left: 50 }}
              grid={{ vertical: true, horizontal: true }}
              sx={{
                "& .MuiBarElement-root": {
                  rx: 4,
                },
              }}
            />
          ) : (
            <div className="chart-empty">No data available</div>
          )}
        </div>
      </div>
      </div>
      )}

      <div className={`dash-six-row${hasPermission("dashboard-income-expense-data-view") ? "" : " is-side-only"}`}>
      {hasPermission("dashboard-income-expense-data-view") && (
      <div className="chart-card">
        <div className="chart-card-header">
          <div className="chart-card-title-group">
            <div className="chart-card-icon is-tile is-navy">
              <i className="bx bx-buildings" aria-hidden="true"></i>
            </div>
            <div>
              <h3 className="chart-card-title">Income vs Expense</h3>
              <p className="chart-card-subtitle-text">
                Monthly income and expense comparison
              </p>
            </div>
          </div>
          <div className="chart-legend-indicators">
            <span className="chart-legend-item">
              <span className="chart-legend-dot" style={{ background: "#1E3A93" }}></span>
              Income
            </span>
            <span className="chart-legend-item">
              <span className="chart-legend-dot" style={{ background: "#F5A623" }}></span>
              Expense
            </span>
          </div>
        </div>
        <div className="chart-card-body">
          {ovalLoading ? (
            <div className="chart-loader">
              <OvalLoader color="#e53935" />
            </div>
          ) : chartDataSet2.length > 0 ? (
            <BarChart
              dataset={chartDataSet2}
              xAxis={[{ dataKey: "month", scaleType: "band", categoryGapRatio: 0.35, barGapRatio: 0.15 }]}
              yAxis={[
                {
                  valueFormatter: lakhFormatter,
                },
              ]}
              slotProps={{ legend: { hidden: true } }}
              series={[
                {
                  dataKey: "income",
                  label: "Income",
                  valueFormatter: currencyFormatter,
                  color: "#1E3A93",
                },
                {
                  dataKey: "expense",
                  label: "Expense",
                  valueFormatter: currencyFormatter,
                  color: "#F5A623",
                },
              ]}
              height={chartHeight}
              margin={{ top: 20, right: 20, bottom: 30, left: 60 }}
              grid={{ vertical: true, horizontal: true }}
              sx={{
                "& .MuiBarElement-root": {
                  rx: 3,
                },
              }}
            />
          ) : (
            <div className="chart-empty">No data available</div>
          )}
        </div>
      </div>
      )}
      {side ? <div className="dash-six-stack">{side}</div> : null}
      </div>
    </div>
  );
};

export default ChartSwiper;
